import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';
import {
  GaTrackingCategoryPageEventPayload
} from "~shared/modules/ga-tracking/models/business-models/ga-tracking-category-page-event-payload.model";

export class GATrackingCategoryPageViewedEvent implements GATrackingEvent {

  constructor(private categoryPageEventPayload: GaTrackingCategoryPageEventPayload) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CategoryPageViewed;
  }

  getPayload(): GATrackingEventPayload {
    const { categoryName } = this.categoryPageEventPayload;

    return {
      event: GaTrackingEventName.CategoryPage,
      category: GaTrackingEventCategory.Category,
      label: categoryName ? categoryName : '',
      gtmCustom: this.categoryPageEventPayload
    };
  }
}
